import { defineComponent } from 'vue';
export default defineComponent({
    props: {
        listTitle: {
            default: '',
            type: String
        },
        size: {
            default: 'normal',
            type: String
        },
        more: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        showMore() {
            this.$emit('showMore');
        }
    },
    setup() {
        return {};
    }
});
